// Filtro por PAR da dupla no fluxo MAD (COT-03) — ports de index.tsx:730-752
// (memo `optionsPairs`) e 3505-3548 (ramo `activeTabDirector === 'mad'` de
// filterStageData). Sem React: o memo vira função pura sobre playerInfo. Nenhum
// import de normal/ (isolamento AD-001).

import { MadRuleContext } from './context';
import { PlayerFields } from '../shared/types';

export interface PairOption {
  label: string | undefined;
  value: string;
}

// Opções do seletor de par a partir de `playerInfo.mad_dupla` — port de
// index.tsx:730-752. Primeira opção é sempre o próprio gestor (label = nome_guerra);
// cada parceiro da dupla vira `nome_guerra (chave)`. Sem `_id` no gestor → [].
export function optionsPairs(playerInfo: PlayerFields | undefined): PairOption[] {
  if (!playerInfo?._id) return [];

  const def: PairOption[] = [
    {
      label: playerInfo?.nome_guerra,
      value: playerInfo?._id,
    },
  ];

  return [
    ...def,
    ...(Array.isArray(playerInfo.mad_dupla)
      ? playerInfo.mad_dupla.map((x: any) => ({
          label: `${x.nome_guerra} (${x.chave})`,
          value: x._id,
        }))
      : []),
  ];
}

// Universo filtrado pelo par selecionado (COT-03) — port de index.tsx:3508-3548.
// Dois modos:
//  - par ≠ eu (parceiro escolhido): tasks em que o par aparece como original_manager,
//    evaluator OU non_evaluator (as realizações que ELE tocou).
//  - par == eu (ou sem seleção): minhas realizações (om/evaluator/non_evaluator = eu),
//    EXCLUINDO as que já pertencem a algum parceiro da dupla (evita duplicidade — a
//    dupla age como um, R-21). `duoIds` vem de ctx.duplaIds (mad_dupla normalizado).
export function filterByPair(tasks: any[], pairSelected: string | undefined, ctx: MadRuleContext): any[] {
  const playerInfo: any = ctx.playerInfo;

  if (!Array.isArray(tasks)) return [];

  if (!!pairSelected && pairSelected !== playerInfo?._id) {
    return tasks.filter((task: any) => {
      if (task.original_manager && task.original_manager === pairSelected) {
        return true;
      }

      if (Array.isArray(task.evaluator) && !!task.evaluator.includes(pairSelected)) {
        return true;
      }

      if (Array.isArray(task.non_evaluator) && !!task.non_evaluator.includes(pairSelected)) {
        return true;
      }

      return false;
    });
  }

  const duoIds = ctx.duplaIds;

  return tasks.filter((task: any) => {
    if (
      duoIds.includes(task.original_manager) ||
      (Array.isArray(task.evaluator) && task.evaluator.some((id: string) => duoIds.includes(id))) ||
      (Array.isArray(task.non_evaluator) && task.non_evaluator.some((id: string) => duoIds.includes(id)))
    ) {
      return false;
    }

    if (task.original_manager === playerInfo?._id) {
      return true;
    }
    if (Array.isArray(task.evaluator) && task.evaluator.includes(playerInfo?._id)) {
      return true;
    }
    if (Array.isArray(task.non_evaluator) && task.non_evaluator.includes(playerInfo?._id)) {
      return true;
    }

    return false;
  });
}
